import { useFormContext } from 'react-hook-form';
import { jobExperienceList } from '@/app/register/_jobExperience/constant';
import { FormSchema } from '@/app/register/schema';

const calculateInitialYear = (year: number, month: number) => {
  const inputDate = new Date(year, month - 1); // NOTE: 月は0から11の範囲なので-1する
  const currentDate = new Date();
  const elapsedMillisecond = currentDate.getTime() - inputDate.getTime();

  // NOTE: 1年のミリ秒
  const oneYearMillSecond = 365 * 24 * 60 * 60 * 1000;
  const elapsedYear = Math.floor(elapsedMillisecond / oneYearMillSecond);

  // NOTE: 10年が最大のため
  const maximumYear = 10;
  return elapsedYear > maximumYear ? maximumYear : elapsedYear;
};

type JobItem = (typeof jobExperienceList)[number]['list'][number];

type Props = {
  value: {
    jobId: number;
    jobName: string;
    level: number;
  }[];
  id: JobItem['id'];
  job: JobItem['job'];
  category: (typeof jobExperienceList)[number]['categoryKey'];
};

export default function JobExperience({ value, id, job, category }: Props) {
  const { watch, setValue, getValues } = useFormContext<FormSchema>();

  const jobs = watch(`jobexperience.${category}`);
  const changeJobExperience = (checked: boolean) => {
    const { year, month } = getValues('graduationyear');
    // NOTE: デフォルトでは年数の初期値が1年のため
    const defaultInitialYear = 1;
    const initialYear =
      year && month
        ? calculateInitialYear(Number(year), Number(month))
        : defaultInitialYear;

    if (checked) {
      setValue(
        `jobexperience.${category}`,
        [
          ...jobs,
          {
            jobId: id,
            jobName: job,
            level: initialYear
          }
        ],
        { shouldDirty: true }
      );
    } else {
      const filteredJobs = jobs.filter(({ jobId }) => jobId !== id);
      setValue(`jobexperience.${category}`, filteredJobs, {
        shouldDirty: true
      });
    }
  };

  return (
    <label className="relative flex py-[17px]">
      <div className="mr-auto pt-[2px]">{job}</div>
      <input
        type="checkbox"
        className="custom-checkbox hidden"
        onChange={e => changeJobExperience(e.target.checked)}
        checked={value.some(({ jobId }) => jobId === id)}
      />
      <span
        className={`absolute right-[10px] top-[21px] block h-[18px] w-[18px] rounded-[2px] ${
          value.some(({ jobId }) => jobId === id)
            ? 'bg-primary-500 after:absolute after:left-[3px] after:top-[4px] after:h-[7px] after:w-[12px] after:rotate-[-45deg] after:border-b-[2px] after:border-l-[2px] after:border-solid after:border-white'
            : 'border-[2px] border-solid border-black opacity-50'
        }`}
      ></span>
    </label>
  );
}
